import React, {useEffect} from "react";
import {Button, Grid} from "semantic-ui-react";
import {observer} from "mobx-react-lite";
import TextField from "../Shared/TextField";
import store from "./SettingsPageStore";
import {InformationPanelItem} from "../Dashboard/InformationPanelItem";
import FieldWithCheckbox from "../Shared/FieldWithCheckbox";

function SettingsPage() {
    useEffect(() => {
        void store.load();
        return function cleanup() {
            store.cleanup();
        }
    }, []);
    return <Grid padded={false}>
        <Grid.Column widescreen={8} computer={11} largeScreen={8} mobile={12} tablet={12}>
            <InformationPanelItem header={'Настройки'}>
                <Grid>
                    {store.requirePinForSettingsChange &&
                        <TextField required name={'Пин код'}
                                   type={'password'}
                                   tip={'Минимум 4 символа, максимум 16'}
                                   onChange={value => store.setPinCode(value)}
                                   value={store.pinCode}/>}
                    <FieldWithCheckbox name={'Запрещать изменение настроек без пин кода'}
                                       width={14}
                                       tip={'При включении данной настройки, только администратор сможет изменять настройки приложения без пин кода'}
                                       value={store.requirePinForSettingsChange}
                                       onChange={value => store.setRequirePinForSettingsChange(value)}/>
                    <Grid.Row>
                        <Grid.Column>
                            <Button disabled={!store.canSave}
                                    color={'teal'}
                                    onClick={() => store.save()}
                                    floated={'right'}>Сохранить настройки</Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </InformationPanelItem>
        </Grid.Column>
    </Grid>
}

export default observer(SettingsPage);